import React, { useEffect, useState } from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { SortableTable } from 'common/components/SortableTable';
import { getCandidates } from './actions/getCandidates';
import PassportModal from './PassportModal';

// Item 6 — admin candidate progress/status list, with an Item-7 "View" action per row
// that opens the read-only passport summary.
const TABLE_HEADERS = [
  { id: 'crn', align: 'left', numeric: false, label: 'CRN' },
  { id: 'name', align: 'left', numeric: false, label: 'NAME' },
  { id: 'discipline', align: 'left', numeric: false, label: 'DISCIPLINE' },
  { id: 'role', align: 'left', numeric: false, label: 'ROLE' },
  { id: 'sponsor', align: 'left', numeric: false, label: 'SPONSOR' },
  { id: 'status', align: 'left', numeric: false, label: 'STATUS' },
  { id: 'view', align: 'right', numeric: false, label: '' },
];

function createData(row, onView) {
  return [
    { id: 'crn', value: row.crn },
    { id: 'name', value: row.name },
    { id: 'discipline', value: row.discipline },
    { id: 'role', value: row.role },
    { id: 'sponsor', value: row.sponsor },
    { id: 'status', value: row.status },
    {
      id: 'view',
      align: 'right',
      value: (
        <Button size="small" variant="outlined" onClick={() => onView(row)}>
          View
        </Button>
      ),
    },
  ];
}

const Candidates = () => {
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);

  const handleView = (row) => {
    setSelected(row);
    setOpen(true);
  };

  useEffect(() => {
    let mounted = true;
    getCandidates().then((candidates) => {
      if (mounted) setRows(candidates.map((c) => createData(c, handleView)));
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Grid item xs={12}>
      <Typography variant="h5" style={{ marginTop: 16, marginBottom: 8 }}>
        Candidates
      </Typography>
      <SortableTable
        name="admin-candidates"
        headers={TABLE_HEADERS}
        rows={rows}
        defaultSortColumnIndex={1}
        searchable
        searchColumnName="name"
      />
      <PassportModal open={open} candidate={selected} onClose={() => setOpen(false)} />
    </Grid>
  );
};

export default Candidates;
